import styles from "@/../src/components/VideoWithThumbnail/VideoConsentPopup/VideoConsentPopup.module.scss";
import RED_INFO from "@/assets/images/red_info.svg";
import { Image } from "@/components/Image";
import { routes } from "@/constants/routes";
import { Button } from "components/Button";
import { Typography } from "components/Typography";
import { BTN_SIZE, BTN_VARIANTS } from "constants/components";
import { Link } from "react-router-dom";

export type VideoConsentPopupProps = {
  onAccept: () => void;
  onReject: () => void;
};

export const VideoConsentPopup: React.FC<VideoConsentPopupProps> = ({
  onAccept,
  onReject,
}) => (
  <section
    className={styles.consent_prompt}
    role="alertdialog"
    aria-labelledby="video-consent-heading"
    aria-describedby="video-consent-description"
  >
    <div className={styles.icon_wrapper} aria-hidden="true">
      <Image
        source={RED_INFO}
        altText="Cookie consent required"
        className={styles.icon}
      />
    </div>

    <Typography
      id="video-consent-heading"
      variant="h3"
      title="Cookie consent needed"
      className={styles.heading}
    >
      Cookie consent needed
    </Typography>

    <Typography
      id="video-consent-description"
      variant="p"
      title="cookie consent description"
      className={styles.description}
    >
      To watch this video, please accept targeting cookies. We use them to
      enable video streaming and improve your experience. Learn more in our{" "}
      <Link
        onClick={onReject}
        to={routes.privacyStatement.path}
        className={styles.privacy_link}
        aria-label="Privacy Statement"
      >
        Privacy Statement
      </Link>
    </Typography>

    <div
      className={styles.button_group}
      role="button group"
      aria-label="Cookie consent actions"
    >
      <Button
        type={BTN_VARIANTS.PRIMARY}
        size={BTN_SIZE.LARGE}
        onClick={onAccept}
        title="Accept and Play Video"
      >
        Accept and Play Video
      </Button>
      <Button
        type={BTN_VARIANTS.SECONDARY}
        size={BTN_SIZE.LARGE}
        onClick={onReject}
        title="Continue Without Video"
      >
        Continue Without Video
      </Button>
    </div>
  </section>
);
